import { Component, input } from '@angular/core';

@Component({
  selector: 'workflow-finxone-tooltip',
  standalone: false,
  templateUrl: './workflow-finxone-tooltip.component.html',
  styleUrls: ['./workflow-finxone-tooltip.component.scss'],
})
export class WorkflowTooltipComponent {
  readonly tooltipContent = input('');
  readonly iconClass = input('ml-2');
  readonly iconName = input('info-circle');

  public showTooltip = false;

  public toggleTooltip(): void {
    this.showTooltip = !this.showTooltip;
  }
}
